// extracted by mini-css-extract-plugin
module.exports = {"lightBackground":"#fafafa","darkBackground":"#171717","lightSecondaryColor":"#66bb6a","darkSecondaryColor":"#fdca13"};